<template>
   <div class="avatar" :style="style" :class="{activity: activity}">
      <img v-if="currentUser && currentUser.c_avatar" :src="this.AVATARS + currentUser.c_avatar" :style="imgStyle" >
      <span v-else class="user-initials">{{initials}}</span>
   </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {

   data() {
      return {
      }
   },

   props: {
      dim: Number,
      hide_indicator: Boolean,
      circle: Boolean,
      activity: Boolean
   },

   created() {
      if (!this.user) { //default to logged in user
         this.fetchUserProfile({vm: this});
         // let self = this;
         // $.post(
         //    this.BARD_HOST + "/user/profile",
         //    {
         //       'token': localStorage.getItem('token')
         //    }, function(data) {
         //       if (!data.error) {
         //          self.currentUser = data;
         //       } else {
         //          self.handleFailedAPICall('/user/profile', 'UserProfileCard', data);
         //       }
         //    }
         // ).fail(function(e) {
         //    console.log("Error with /user/profile: " + e.responseText);
         // }); 

      }
   },

   computed: {
      ...mapState('global', [
         'currentUser'
      ]),

      style() {
         let styleStr = '';
         if (this.dim) {
            styleStr += 'width: ' + this.dim + 'px; height: ' + this.dim + 'px;';
         }
         return styleStr;
      },

      imgStyle() {
         let styleStr = '';
         if (this.circle) {
            styleStr += 'border-radius: 50%;';
         }
         return styleStr;
      },

      initials() {
         if (this.currentUser && this.currentUser.c_first_name && this.currentUser.c_last_name) {
            return this.currentUser.c_first_name[0] + this.currentUser.c_last_name[0];
         }
      }
   },

   methods: {
      ...mapActions('global', [
         'fetchUserProfile'
      ])
   },

   watch: {
      user() {
         this.currentUser = this.user;
      }
   }
}
</script>

<style lang="scss" scoped>
.avatar {
   position: relative;
   // margin: 0 auto;
   height: 80px;
   width: 80px;

   img {
      width: 100%;
      height: 100%;
      object-fit: cover;
   }

   // &::after {
   //    content: '';
   //    position: absolute;
   //    bottom: 0;
   //    right: 0;
   //    width: 22px;
   //    height: 22px;
   //    border-radius: 6px;
   //    border: 3px solid $manage-status-offline;
   //    background-color: black;
   //    box-shadow: 0px 0px 0px 6px black;
   // }

   .user-initials {
      border-radius: 50%;
      background: #797979;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      text-align: center;
      width: 100%;
      height: 100%;
      font-size: .9em;
   }

   &.activity {
      height: 16px;
      width: 16px;
      position: absolute;
      left: -30px;
      top: -5%;
      z-index: 2;
   }
}
</style>